import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67de45a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-md" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "notable-works-container" }
const _hoisted_4 = { class: "info-zone" }
const _hoisted_5 = { class: "flex g-sm my-sm" }
const _hoisted_6 = {
  key: 0,
  style: {"max-width":"33%","width":"50%"}
}
const _hoisted_7 = { style: {"max-width":"66%"} }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "map-zone" }
const _hoisted_10 = ["id"]

import L from "leaflet";
import "leaflet/dist/leaflet.css";

import { MAPBOX_TOKEN, MAPBOX_TOKEN_URL } from "@/globals";
import { onMounted, ref } from "vue";
import type { MapItemConfig } from "@/types/map";
import { useI18n } from "vue-i18n";
import { Navigation, Pagination } from "swiper";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotableWorksPage',
  setup(__props) {

const { t } = useI18n();
const mapID = ref("notable-works-map");

const pacaIcon = L.icon({
  iconUrl: "/map-marker.png",
  iconSize: [30, 30], // size of the icon
  iconAnchor: [15, 30], // point of the icon which will correspond to marker's location
});

const mapItems = ref<MapItemConfig[]>([
  {
    name: "Cultuurcentrum De Factorij",
    latitude: 50.88440895684246,
    longitude: 4.470129269384744,
    text: "cultuurcentrum_text",
    imgs: [
      require("@/assets/imgs/notable-works/cultuurcentrum/1.jpg"),
      require("@/assets/imgs/notable-works/cultuurcentrum/2.jpg"),
    ],
  },
  {
    name: "Test",
    latitude: 51.88440895684246,
    longitude: 5.470129269384744,
    text: "test_text",
    imgs: [],
  },
]);

const selectedItem = ref<MapItemConfig>(mapItems.value[0]);

onMounted(() => {
  const map = L.map(mapID.value, {
    center: [50.52583753604757, 5.028475908191985],
    zoom: 7,
  });

  L.tileLayer(MAPBOX_TOKEN_URL, {
    attribution:
      'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    maxZoom: 18,
    id: "mapbox/streets-v11",
    tileSize: 512,
    zoomOffset: -1,
    accessToken: MAPBOX_TOKEN,
  }).addTo(map);

  for (const item of mapItems.value) {
    L.marker([item.latitude, item.longitude], { icon: pacaIcon })
      .addTo(map)
      .on("click", () => (selectedItem.value = item));
  }
});

return (_ctx: any,_cache: any) => {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!
  const _component_CardItem = _resolveComponent("CardItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)("notableWorks")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_CardItem, {
          class: "m-md",
          title: selectedItem.value.name
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (selectedItem.value.text)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(t)(selectedItem.value.text)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Swiper, {
                  modules: [_unref(Navigation), _unref(Pagination)],
                  navigation: true,
                  pagination: true,
                  "slides-per-view": 1
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedItem.value.imgs, (img, i) => {
                      return (_openBlock(), _createBlock(_component_SwiperSlide, { key: i }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: img,
                            style: {"object-fit":"cover","max-width":"100%"}
                          }, null, 8, _hoisted_8)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modules"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          id: mapID.value,
          class: "map-container"
        }, null, 8, _hoisted_10)
      ])
    ])
  ]))
}
}

})